import React,{useState,useEffect} from 'react'

export default function ForecastCard(props) {
    const [CurrDate, setcurrDate] = useState("");
    const {weather_state_name,max_temp,min_temp}=props.weatherArr;
    useEffect(()=>{
        if(props.nextDate!==1){
            var tom=new Date();
            tom.setHours(0,0,0);
            tom.setDate(tom.getDate()+props.nextDate);
            tom.toLocaleString('default');
            var arr=tom.toString().trim().split(" ");
            var date=arr[0]+","+arr[2]+" "+arr[1];
            setcurrDate(date);
        }
        else {
            setcurrDate("Tomorrow");
        }

        console.log(props.weatherArr);
        
    },[CurrDate,props.nextDate]);
    
    
    return (
        <div class="forecastCard text">
            <p>{CurrDate}</p>
            <div className="flexCenter">
                <img src={weather_state_name.replace(' ','')+".png"} alt="weatherimage"></img>
            </div>
           
            <div className="flex forecastTemp">
                <p>{max_temp.toFixed(2)}<span className="degree">°C</span></p>
                <p>{min_temp.toFixed(2)}<span className="degree">°C</span></p>
            </div>
        </div>
    )
}
